export const ENTER = 'Enter';
export const CANCEL = 'CANCEL';
export const SEARCH = 'Search';
//# sourceMappingURL=SearchBoxConstants.js.map